/**
 * Pure helpers behind BsSelect's search box, kept apart from the component so
 * they can be unit-tested without loading Vuetify.
 */
export const SEARCH_THRESHOLD = 10;

/** Mirrors Vuetify's getPropertyFromItem for the shapes callers here use. */
export function propertyOf(item: any, property: any, fallback: any): any {
    if (property == null) return item === undefined ? fallback : item;
    if (typeof property === 'function') return property(item, fallback);
    if (item !== Object(item)) return fallback;
    if (typeof property === 'string') {
        const value = property
            .replace(/\[(\w+)\]/g, '.$1')
            .split('.')
            .reduce((obj: any, key: string) => (obj == null ? undefined : obj[key]), item);
        return value === undefined ? fallback : value;
    }
    if (Array.isArray(property)) {
        const value = property.reduce((obj: any, key: string) => (obj == null ? undefined : obj[key]), item);
        return value === undefined ? fallback : value;
    }
    return fallback;
}

function sameValue(a: any, b: any): boolean {
    if (a === b) return true;
    if (a && b && typeof a === 'object' && typeof b === 'object') {
        try {
            return JSON.stringify(a) === JSON.stringify(b);
        } catch {
            return false;
        }
    }
    return false;
}

/**
 * The items left after searching for `query`: options whose title contains it
 * (case-insensitive), plus every currently chosen option. Section headers and
 * dividers are dropped while a query is active.
 */
export function filterItems(items: any[], query: string, opts: { itemTitle?: any; itemValue?: any; returnObject?: boolean; modelValue?: any }): any[] {
    const q = query.trim().toLowerCase();
    if (!q) return items;
    const itemTitle = opts.itemTitle ?? 'title';
    const itemValue = opts.itemValue ?? 'value';
    const model = opts.modelValue;
    const chosen = model === undefined || model === null ? [] : Array.isArray(model) ? model : [model];
    return items.filter((item) => {
        if (item && typeof item === 'object' && (item.type === 'subheader' || item.type === 'divider' || item.header || item.divider)) return false;
        const title = propertyOf(item, itemTitle, item);
        if (String(title ?? '').toLowerCase().includes(q)) return true;
        if (!chosen.length) return false;
        if (opts.returnObject) return chosen.some((c) => sameValue(c, item));
        const value = propertyOf(item, itemValue, title);
        return chosen.some((c) => sameValue(c, value));
    });
}
